/* Moood Wishlist Mode v4 - moood.fr <-> outils.moood.fr
 * v4 = capture properties[] + nouveau mode transfer (POST /cart/add.js direct)
 * + handler 422 SUR_MESURE_LIMIT (popup limite 7 sur-mesure)
 */
(function() {
  'use strict';

  const API_ADD = 'https://outils.moood.fr/api/public/wishlists/add';
  const API_STATE = 'https://outils.moood.fr/api/public/wishlists/state';
  const API_CART = 'https://outils.moood.fr/api/public/wishlists/cart-permalink';
  const PORTAL_URL = 'https://outils.moood.fr/client/wishlists';

  const STORAGE = {
    TOKEN: 'moood_wl_token',
    ACTIVE: 'moood_wl_active',
    TRANSFER_PENDING: 'moood_wl_transfer_pending',
    INITIAL_ITEMS: 'moood_wl_initial_items',
    INITIAL_AMOUNT: 'moood_wl_initial_amount',
    SESSION_ITEMS: 'moood_wl_session_items',
    SESSION_AMOUNT: 'moood_wl_session_amount'
  };

  const COLORS = {
    primary: '#174E44',
    accent: '#DFAE3A',
    cart: '#C4622A',
    cartHover: '#a35221',
    error: '#dc2626',
    success: '#16a34a'
  };

  // Sauvegarder la fetch native AVANT tout intercept
  const NATIVE_FETCH = window.fetch.bind(window);

  let state = {
    initialItems: 0,
    initialAmount: 0,
    sessionItems: 0,
    sessionAmount: 0,
    wishlistName: '',
    items: []
  };

  const eurFmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function eur(v) { return eurFmt.format(Number(v) || 0); }
  function plural(n, w) { return n > 1 ? w + 's' : w; }

  function addMooodCustomProps(props) {
    // Le theme moood stocke certaines options dans des variables globales
    // (le wrap fetch les injecte au moment du /cart/add, mais on intercepte avant)
    if (window.mooOuvertureSelectionnee) {
      props["Sens d'ouverture"] = window.mooOuvertureSelectionnee;
    }
    // Ajouter d'autres window.moo* ici si besoin
  }

  // Properties techniques moood a ne JAMAIS afficher au client
  const HIDDEN_PROPS = new Set([
    'Tranche', 'Configuration', 'Label',
    'Largeur (mm)', 'Longueur (mm)', 'Surface (m²)',
    'Prix total (€)', 'Prix calculé (€)',
    'Supplément options (€)', 'Tarif appliqué (€/m²)'
  ]);

  // Produits sur-mesure OPC : leur variant Shopify est a 0€, le vrai prix est
  // porte par la line-item property cachee __ooCustomPrice (en CENTIMES) qu'une
  // Shopify Function OPC lit pour fixer le prix de ligne. Le save wishlist
  // strippe cette property -> a la restauration il faut la reinjecter, mais
  // UNIQUEMENT pour ces produits. Un meuble configurable standard (caisson +
  // facade + poignee) a un variant a prix NATIF : lui injecter __ooCustomPrice
  // le ferait passer x100 (bug ERP du 2026-07-17). Allowlist deterministe =
  // aucun risque x100 par construction.
  // Cle = product_id numerique (l'endpoint ERP n'a pas le handle en base, cf.
  // RESPONSE-3). Source de verite handles : FIELD_BUILDERS de moo-pack-chain.js
  // + SUPPORTED_SM de configurateur-moood.js. IDs resolus via /products/<h>.js.
  const SUR_MESURE_PRODUCT_IDS = new Set([
    15619798335820, // plan-de-travail-sur-mesure
    15634821644620, // plan-de-travail-sur-mesure-pour-ilot
    15621008359756, // credence-surmesure
    15635131531596, // credence-sur-mesure-grand-gabarit
    15699894731084, // plinthe-sur-mesure
    15699969933644, // etagere-sur-mesure
    15664378741068, // facade-joue-fileur-plinthe-sur-mesure
    15656187756876, // caisson-sur-mesure
    15658777706828, // niche-sur-mesure
    15767353950540, // porte-derobee-sur-mesure
    15783540916556, // colonne-lave-vaisselle-sur-mesure
    15782749274444  // niche-refrigerateur-sur-mesure
  ]);

  // Filtre les properties techniques + extrait le prix custom OPC
  function filterAndExtractPrice(rawProps) {
    const cleanProps = {};
    let customPrice = null;
    for (const [k, v] of Object.entries(rawProps || {})) {
      // Capturer le prix custom OPC (utilise pour les configurateurs sur-mesure)
      if (k === '__ooCustomPrice') {
        const p = parseFloat(String(v).replace(',', '.'));
        if (!isNaN(p) && p > 0) customPrice = p;
        continue;
      }
      if (k === 'Prix total (€)' && customPrice === null) {
        const p = parseFloat(String(v).replace(',', '.'));
        if (!isNaN(p) && p > 0) customPrice = p;
        continue;
      }
      // Filtrer les properties techniques cachees
      if (k.startsWith('_')) continue;
      if (/^field_\d+$/.test(k)) continue;
      if (HIDDEN_PROPS.has(k)) continue;
      cleanProps[k] = v;
    }
    return { properties: cleanProps, customPrice };
  }

  function extractPropertiesFromForm(form) {
    const props = {};
    form.querySelectorAll('[name^="properties["]').forEach(input => {
      const m = input.name.match(/properties\[(.+?)\]/);
      if (m && input.value) props[m[1]] = input.value;
    });
    addMooodCustomProps(props);
    return props;
  }

  function extractPropertiesFromPayload(payload) {
    if (!payload) return {};
    const props = {};
    // JSON-style { properties: { Sens: "Gauche" } }
    if (payload.properties && typeof payload.properties === 'object') {
      Object.assign(props, payload.properties);
    }
    // FormData-style { "properties[Sens]": "Gauche" }
    for (const [k, v] of Object.entries(payload)) {
      const m = k.match(/^properties\[(.+?)\]$/);
      if (m && v) props[m[1]] = v;
    }
    addMooodCustomProps(props);
    return props;
  }

  function detectModeFromUrl() {
    const params = new URLSearchParams(window.location.search);

    // Mode transfer (priorité)
    if (params.get('wishlist_transfer') === '1' && params.get('t')) {
      localStorage.setItem(STORAGE.TOKEN, params.get('t'));
      localStorage.setItem(STORAGE.TRANSFER_PENDING, '1');
      params.delete('wishlist_transfer');
      params.delete('t');
      params.delete('return_to');
      const s = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash);
      return;
    }

    // Mode wishlist
    if (params.get('wishlist_mode') === '1' && params.get('t')) {
      localStorage.setItem(STORAGE.TOKEN, params.get('t'));
      localStorage.setItem(STORAGE.ACTIVE, '1');
      localStorage.setItem(STORAGE.SESSION_ITEMS, '0');
      localStorage.setItem(STORAGE.SESSION_AMOUNT, '0');
      localStorage.removeItem(STORAGE.INITIAL_ITEMS);
      localStorage.removeItem(STORAGE.INITIAL_AMOUNT);
      // Exclusion mutuelle : couper devis + commande pour eviter double interception
      ['moood_devis_token', 'moood_devis_id', 'moood_devis_active', 'moood_devis_session_lines',
       'moood_cmd_token', 'moood_cmd_id', 'moood_cmd_active', 'moood_cmd_session_items'
      ].forEach(k => localStorage.removeItem(k));
      params.delete('wishlist_mode');
      params.delete('t');
      const s = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash);
    }
  }

  function loadState() {
    state.initialItems = parseInt(localStorage.getItem(STORAGE.INITIAL_ITEMS) || '0', 10);
    state.initialAmount = parseFloat(localStorage.getItem(STORAGE.INITIAL_AMOUNT) || '0');
    state.sessionItems = parseInt(localStorage.getItem(STORAGE.SESSION_ITEMS) || '0', 10);
    state.sessionAmount = parseFloat(localStorage.getItem(STORAGE.SESSION_AMOUNT) || '0');
  }

  function saveState() {
    localStorage.setItem(STORAGE.INITIAL_ITEMS, String(state.initialItems));
    localStorage.setItem(STORAGE.INITIAL_AMOUNT, String(state.initialAmount));
    localStorage.setItem(STORAGE.SESSION_ITEMS, String(state.sessionItems));
    localStorage.setItem(STORAGE.SESSION_AMOUNT, String(state.sessionAmount));
  }

  async function fetchState({ initialOnly = false } = {}) {
    const token = localStorage.getItem(STORAGE.TOKEN);
    if (!token) return;
    try {
      const res = await NATIVE_FETCH(`${API_STATE}?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      if (!data.success) {
        if (res.status === 401) {
          showToast('Session wishlist expirée. Retour au portail...', 'error', 4000);
          setTimeout(goToPortal, 2500);
        }
        return;
      }
      state.wishlistName = data.wishlistName;
      state.items = data.items || [];
      if (initialOnly && localStorage.getItem(STORAGE.INITIAL_ITEMS) === null) {
        state.initialItems = data.totalItems;
        state.initialAmount = data.totalAmount;
        state.sessionItems = 0;
        state.sessionAmount = 0;
        saveState();
      }
      updateBanner();
    } catch (err) {
      console.error('[wl] fetchState error', err);
    }
  }

  function injectStyles() {
    if (document.getElementById('moood-wl-styles')) return;
    const style = document.createElement('style');
    style.id = 'moood-wl-styles';
    style.textContent = `
      body.moood-wishlist-mode { padding-top: 60px !important; }
      #moood-wl-banner {
        position: fixed; top: 0; left: 0; right: 0; z-index: 99999;
        background: ${COLORS.primary}; color: #fff;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
        box-shadow: 0 2px 12px rgba(0,0,0,0.2);
      }
      #moood-wl-banner .inner {
        max-width: 1400px; margin: 0 auto; padding: 10px 16px;
        display: flex; align-items: center; justify-content: space-between;
        gap: 16px; flex-wrap: wrap;
      }
      #moood-wl-banner .info { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 240px; }
      #moood-wl-banner .info .title { font-weight: 700; font-size: 14px; }
      #moood-wl-banner .info .stats { font-size: 13px; opacity: 0.95; line-height: 1.4; }
      #moood-wl-banner .info .stats strong { font-weight: 700; }
      #moood-wl-banner .info .stats .sep { opacity: 0.5; margin: 0 6px; }
      #moood-wl-banner .info .stats .added { color: ${COLORS.accent}; }
      #moood-wl-banner .actions { display: flex; gap: 8px; align-items: center; position: relative; flex-wrap: wrap; }
      #moood-wl-banner button {
        background: #fff; color: ${COLORS.primary};
        border: none; padding: 8px 14px; border-radius: 6px;
        font-size: 13px; font-weight: 600; cursor: pointer;
        transition: background 0.15s, transform 0.1s;
        font-family: inherit;
      }
      #moood-wl-banner button:hover { background: #f0f0f0; }
      #moood-wl-banner button:active { transform: scale(0.97); }
      #moood-wl-banner button:disabled { opacity: 0.6; cursor: not-allowed; }
      #moood-wl-banner button.primary {
        background: ${COLORS.cart}; color: #fff; font-weight: 700;
      }
      #moood-wl-banner button.primary:hover:not(:disabled) { background: ${COLORS.cartHover}; }
      #moood-wl-banner button.secondary {
        background: transparent; color: #fff;
        border: 1px solid rgba(255,255,255,0.4);
      }
      #moood-wl-banner button.secondary:hover { background: rgba(255,255,255,0.1); }

      #moood-wl-popup {
        position: fixed; top: 88px; right: 16px; z-index: 99998;
        background: #fff; color: #1a1a1a;
        border-radius: 12px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
        width: 380px; max-width: calc(100vw - 32px);
        max-height: 70vh; overflow: hidden;
        display: none;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      }
      #moood-wl-popup.show { display: flex; flex-direction: column; }
      #moood-wl-popup .pop-header {
        padding: 14px 16px; border-bottom: 1px solid #e5e5e5;
        font-weight: 700; font-size: 15px; color: ${COLORS.primary};
      }
      #moood-wl-popup .pop-list { flex: 1; overflow-y: auto; padding: 4px 0; }
      #moood-wl-popup .pop-empty { padding: 24px 16px; text-align: center; color: #888; font-size: 13px; }
      #moood-wl-popup .pop-item {
        display: flex; gap: 10px; padding: 10px 16px;
        border-bottom: 1px solid #f0f0f0; align-items: flex-start;
      }
      #moood-wl-popup .pop-item:last-child { border-bottom: none; }
      #moood-wl-popup .pop-item img {
        width: 48px; height: 48px; object-fit: cover;
        border-radius: 6px; background: #f5f5f5; flex-shrink: 0;
      }
      #moood-wl-popup .pop-item .ttl { flex: 1; min-width: 0; }
      #moood-wl-popup .pop-item .ttl .name { font-size: 13px; font-weight: 600; line-height: 1.3; }
      #moood-wl-popup .pop-item .ttl .meta { font-size: 12px; color: #666; margin-top: 2px; }
      #moood-wl-popup .pop-item .ttl .props { font-size: 11px; color: ${COLORS.cart}; margin-top: 3px; line-height: 1.3; }
      #moood-wl-popup .pop-item .qty { font-size: 13px; font-weight: 600; color: ${COLORS.primary}; white-space: nowrap; }
      #moood-wl-popup .pop-footer {
        padding: 14px 16px; border-top: 1px solid #e5e5e5;
        background: #fafafa;
        display: flex; justify-content: space-between; align-items: center;
        font-weight: 700;
      }
      #moood-wl-popup .pop-footer .lbl { font-size: 13px; color: #555; }
      #moood-wl-popup .pop-footer .val { font-size: 16px; color: ${COLORS.primary}; }

      #moood-wl-toast {
        position: fixed; bottom: 24px; right: 24px; z-index: 100000;
        background: ${COLORS.success}; color: #fff;
        padding: 14px 20px; border-radius: 8px;
        font-family: system-ui, -apple-system, sans-serif;
        font-size: 14px; font-weight: 600;
        box-shadow: 0 4px 16px rgba(0,0,0,0.2);
        transform: translateY(100px); opacity: 0;
        transition: all 0.3s ease;
        max-width: 380px;
      }
      #moood-wl-toast.show { transform: translateY(0); opacity: 1; }
      #moood-wl-toast.error { background: ${COLORS.error}; }

      #moood-wl-overlay {
        position: fixed; inset: 0; z-index: 100001;
        background: rgba(23, 78, 68, 0.92);
        display: flex; align-items: center; justify-content: center;
        flex-direction: column; gap: 24px;
        color: #fff; font-family: system-ui, sans-serif;
      }
      #moood-wl-overlay .spinner {
        width: 56px; height: 56px;
        border: 4px solid rgba(255,255,255,0.2);
        border-top-color: #fff;
        border-radius: 50%;
        animation: moood-wl-spin 0.8s linear infinite;
      }
      @keyframes moood-wl-spin { to { transform: rotate(360deg); } }
      #moood-wl-overlay .msg { font-size: 18px; font-weight: 600; }
      #moood-wl-overlay .sub { font-size: 14px; opacity: 0.85; }

      @media (max-width: 720px) {
        body.moood-wishlist-mode { padding-top: 124px !important; }
        #moood-wl-banner .inner { flex-direction: column; align-items: stretch; padding: 10px 12px; gap: 8px; }
        #moood-wl-banner .info .stats { font-size: 12px; }
        #moood-wl-banner .actions { justify-content: space-between; width: 100%; }
        #moood-wl-banner button { flex: 1; padding: 8px 6px; font-size: 12px; }
        #moood-wl-popup { top: 144px; right: 8px; left: 8px; width: auto; }
      }
    `;
    document.head.appendChild(style);
  }

  function injectBanner() {
    if (document.getElementById('moood-wl-banner')) return;
    const banner = document.createElement('div');
    banner.id = 'moood-wl-banner';
    banner.innerHTML = `
      <div class="inner">
        <div class="info">
          <div class="title">🎁 Mode wishlist actif</div>
          <div class="stats" id="moood-wl-stats">Chargement...</div>
        </div>
        <div class="actions">
          <button id="moood-wl-preview">Aperçu</button>
          <button id="moood-wl-cart" class="primary">Ajouter au panier</button>
          <button id="moood-wl-view">Voir ma wishlist</button>
          <button id="moood-wl-exit" class="secondary">Quitter</button>
        </div>
      </div>
    `;
    document.body.insertBefore(banner, document.body.firstChild);
    document.body.classList.add('moood-wishlist-mode');
    document.getElementById('moood-wl-view').addEventListener('click', goToPortal);
    document.getElementById('moood-wl-exit').addEventListener('click', exitMode);
    document.getElementById('moood-wl-cart').addEventListener('click', transferToCart);

    const previewBtn = document.getElementById('moood-wl-preview');
    previewBtn.addEventListener('mouseenter', showPopup);
    previewBtn.addEventListener('click', togglePopup);
  }

  function updateBanner() {
    const stats = document.getElementById('moood-wl-stats');
    if (stats) {
      const totalItems = state.initialItems + state.sessionItems;
      const totalAmount = state.initialAmount + state.sessionAmount;
      stats.innerHTML = `
        Avant : <strong>${state.initialItems}</strong> ${plural(state.initialItems, 'produit')} (<strong>${eur(state.initialAmount)}</strong>)
        <span class="sep">·</span>
        <span class="added">Ajoutés : <strong>${state.sessionItems}</strong> (<strong>${eur(state.sessionAmount)}</strong>)</span>
        <span class="sep">·</span>
        Total : <strong>${totalItems}</strong> (<strong>${eur(totalAmount)}</strong>)
      `;
    }
    const cartBtn = document.getElementById('moood-wl-cart');
    if (cartBtn) {
      const total = state.initialItems + state.sessionItems;
      cartBtn.disabled = total === 0;
    }
    const popup = document.getElementById('moood-wl-popup');
    if (popup && popup.classList.contains('show')) renderPopupContent();
  }

  let popupHideTimer = null;

  function ensurePopup() {
    let popup = document.getElementById('moood-wl-popup');
    if (popup) return popup;
    popup = document.createElement('div');
    popup.id = 'moood-wl-popup';
    popup.addEventListener('mouseenter', () => clearTimeout(popupHideTimer));
    popup.addEventListener('mouseleave', () => {
      popupHideTimer = setTimeout(hidePopup, 200);
    });
    document.body.appendChild(popup);
    return popup;
  }

  function renderPopupContent() {
    const popup = ensurePopup();
    const totalItems = state.initialItems + state.sessionItems;
    const totalAmount = state.initialAmount + state.sessionAmount;
    if (!state.items || state.items.length === 0) {
      popup.innerHTML = `
        <div class="pop-header">Aperçu de votre wishlist</div>
        <div class="pop-empty">Votre wishlist est vide.<br>Ajoutez des produits en cliquant sur "Ajouter au panier".</div>
      `;
      return;
    }
    const itemsHtml = state.items.map(it => {
      const propsList = it.properties && Object.keys(it.properties).length
        ? Object.entries(it.properties).map(([k, v]) => `${k} : ${v}`).join(' · ')
        : '';
      return `
        <div class="pop-item">
          ${it.imageSrc ? `<img src="${it.imageSrc}" alt="">` : '<div style="width:48px;height:48px;background:#f5f5f5;border-radius:6px;flex-shrink:0;"></div>'}
          <div class="ttl">
            <div class="name">${it.title || 'Produit'}</div>
            <div class="meta">${it.variantTitle ? it.variantTitle + ' · ' : ''}${eur(it.price)} l'unité</div>
            ${propsList ? `<div class="props">🔧 ${propsList}</div>` : ''}
          </div>
          <div class="qty">×${it.quantity}</div>
        </div>
      `;
    }).join('');
    popup.innerHTML = `
      <div class="pop-header">Aperçu de votre wishlist${state.wishlistName ? ' - ' + state.wishlistName : ''}</div>
      <div class="pop-list">${itemsHtml}</div>
      <div class="pop-footer">
        <span class="lbl">${totalItems} ${plural(totalItems, 'produit')}</span>
        <span class="val">${eur(totalAmount)}</span>
      </div>
    `;
  }

  function positionPopup() {
    const popup = document.getElementById('moood-wl-popup');
    const btn = document.getElementById('moood-wl-preview');
    if (!popup || !btn) return;
    if (window.innerWidth <= 720) {
      popup.style.top = '';
      popup.style.left = '';
      popup.style.right = '';
      return;
    }
    const rect = btn.getBoundingClientRect();
    const popupWidth = 380;
    const viewportWidth = window.innerWidth;
    const top = rect.bottom + 8;
    let left = rect.left;
    if (left + popupWidth > viewportWidth - 16) {
      left = Math.max(16, viewportWidth - popupWidth - 16);
    }
    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
    popup.style.right = 'auto';
  }

  function showPopup() {
    clearTimeout(popupHideTimer);
    renderPopupContent();
    const popup = ensurePopup();
    popup.classList.add('show');
    positionPopup();
  }

  function hidePopup() {
    const popup = document.getElementById('moood-wl-popup');
    if (popup) popup.classList.remove('show');
  }

  function togglePopup(e) {
    e.stopPropagation();
    const popup = document.getElementById('moood-wl-popup');
    if (popup && popup.classList.contains('show')) hidePopup();
    else showPopup();
  }

  function setupPopupHoverLeave() {
    document.addEventListener('mousemove', function(e) {
      const popup = document.getElementById('moood-wl-popup');
      const btn = document.getElementById('moood-wl-preview');
      if (!popup || !btn || !popup.classList.contains('show')) return;
      const overBtn = btn.contains(e.target);
      const overPopup = popup.contains(e.target);
      if (!overBtn && !overPopup) {
        clearTimeout(popupHideTimer);
        popupHideTimer = setTimeout(hidePopup, 300);
      }
    });
  }

  function showToast(message, type = 'success', duration = 3000) {
    const existing = document.getElementById('moood-wl-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.id = 'moood-wl-toast';
    if (type === 'error') toast.classList.add('error');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }

  // ─── Popup limite produits sur-mesure (handler 422 SUR_MESURE_LIMIT) ───
  // Aligné sur le brief Claude Code (outils.moood.fr) : la response API
  // contient { code: 'SUR_MESURE_LIMIT', currentCount, max, error }
  function showSurMesureLimitDialog(currentCount, max) {
    if (document.getElementById('moood-wl-sm-popup')) return;
    const limit = max || 7;
    const overlay = document.createElement('div');
    overlay.id = 'moood-wl-sm-popup';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(18,49,43,0.7);z-index:100002;display:flex;align-items:center;justify-content:center;padding:20px;';
    overlay.innerHTML = '<div style="background:#fff8ed;border:1.5px solid #12312b;border-radius:18px;box-shadow:6px 6px 0 0 #DFAE3A;max-width:480px;padding:32px 28px;font-family:Inter,-apple-system,sans-serif;color:#12312b;">' +
      '<h3 style="font-style:italic;font-weight:900;font-size:22px;margin:0 0 14px;line-height:1.2;">Limite atteinte</h3>' +
      '<p style="font-family:Caveat,cursive;font-size:20px;color:#6f7f7b;margin:0 0 18px;line-height:1.3;">Cette wishlist contient déjà ' + limit + ' produits sur-mesure</p>' +
      '<p style="font-size:15px;line-height:1.5;margin:0 0 22px;">Pour des raisons techniques, on ne peut pas dépasser ' + limit + ' produits sur-mesure différents par commande. Tu peux retirer un produit sur-mesure existant pour ajouter celui-ci, ou créer une seconde wishlist.</p>' +
      '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
        '<button id="moood-wl-sm-close" style="flex:1;background:#12312b;color:#fff8ed;border:1.5px solid #12312b;border-radius:60px;padding:12px 20px;font-family:Inter,sans-serif;font-weight:700;font-size:14px;cursor:pointer;box-shadow:4px 4px 0 0 #C4622A;">J\'ai compris</button>' +
        '<a href="' + PORTAL_URL + '" style="flex:1;background:transparent;color:#12312b;text-align:center;text-decoration:underline;border:none;padding:12px 20px;font-family:Inter,sans-serif;font-weight:600;font-size:13px;align-self:center;">Voir mes sur-mesure</a>' +
      '</div>' +
    '</div>';
    document.body.appendChild(overlay);
    document.getElementById('moood-wl-sm-close').addEventListener('click', function(){ overlay.remove(); });
    overlay.addEventListener('click', function(e){ if (e.target === overlay) overlay.remove(); });
  }

  function showOverlay(msg, sub = '') {
    const existing = document.getElementById('moood-wl-overlay');
    if (existing) existing.remove();
    const overlay = document.createElement('div');
    overlay.id = 'moood-wl-overlay';
    overlay.innerHTML = `
      <div class="spinner"></div>
      <div class="msg">${msg}</div>
      ${sub ? `<div class="sub">${sub}</div>` : ''}
    `;
    document.body.appendChild(overlay);
  }

  function hideOverlay() {
    const overlay = document.getElementById('moood-wl-overlay');
    if (overlay) overlay.remove();
  }

  // Fallback via les globals Liquid de la page produit (jamais plafonnes a 250
  // variants, contrairement a /products/<h>.js). Renvoie null hors page produit
  // ou si le global productId n'est pas expose.
  function productDataFromGlobals(variantId, fallbackImage) {
    const pid = Number(window.mooodProductId);
    if (!isFinite(pid) || pid <= 0) return null;
    let price = 0;
    // Map prix : 2 tableaux alignes (mooodVariantIds[i] <-> mooodVariantPrices[i]),
    // emis seulement pour les produits > 250 variants.
    if (Array.isArray(window.mooodVariantIds) && Array.isArray(window.mooodVariantPrices)) {
      const idx = window.mooodVariantIds.indexOf(Number(variantId));
      if (idx !== -1 && window.mooodVariantPrices[idx] != null) {
        price = window.mooodVariantPrices[idx] / 100;
      }
    }
    if (!price && typeof window.mooodProductPrice === 'number') {
      price = window.mooodProductPrice; // ultime repli (prix produit initial)
    }
    return {
      productId: pid,
      title: window.mooodProductTitle || 'Produit moood',
      variantTitle: null,
      price: price,
      imageSrc: fallbackImage || null
    };
  }

  async function fetchProductData(variantId) {
    let liquidImg = null;
    try {
      if (window.location.pathname.includes('/products/')) {
        const handle = window.location.pathname.split('/products/')[1].split(/[\/\?#]/)[0];
        if (handle) {
          const res = await NATIVE_FETCH(`/products/${handle}.js`);
          if (res.ok) {
            const product = await res.json();
            liquidImg = product.featured_image || null;
            const variant = product.variants.find(v => String(v.id) === String(variantId));
            if (variant) {
              return {
                productId: product.id,
                title: product.title,
                variantTitle: variant.title === 'Default Title' ? null : variant.title,
                price: variant.price / 100,
                imageSrc: variant.featured_image?.src || product.featured_image
              };
            }
            // Variant absent du products.json (plafond 250 variants) : on retombe
            // sur les globals Liquid pour ne PAS renvoyer productId=0 (rejet ERP).
            const fromGlobals = productDataFromGlobals(variantId, product.featured_image);
            if (fromGlobals) return fromGlobals;
          }
        }
      }
    } catch (e) { console.warn('[wl] product fetch failed', e); }
    // products.json indispo ou hors page produit : dernier recours via globals.
    const fromGlobals = productDataFromGlobals(variantId, liquidImg);
    if (fromGlobals) return fromGlobals;
    return { productId: 0, title: 'Produit moood', variantTitle: null, price: 0, imageSrc: null };
  }

  async function sendToWishlist({ variantId, quantity, properties = {} }) {
    const token = localStorage.getItem(STORAGE.TOKEN);
    if (!token) {
      showToast('Session wishlist absente. Reviens sur ton portail.', 'error', 5000);
      return null;
    }
    // Garde-fou : variant non resolu (combinaison sans variant Shopify, ou
    // variant-picker pas encore initialise) -> ne pas envoyer un payload que
    // l'ERP rejettera ("Validation failed"). Message clair a la place.
    const vid = parseInt(variantId, 10);
    if (!isFinite(vid) || vid <= 0) {
      showToast('Sélectionne une configuration valide avant d’ajouter.', 'error', 4000);
      return null;
    }
    const { properties: cleanProps, customPrice } = filterAndExtractPrice(properties);
    const data = await fetchProductData(variantId);
    const finalPrice = customPrice || data.price;
    try {
      const res = await NATIVE_FETCH(API_ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          variantId: vid,
          productId: data.productId,
          title: data.title,
          variantTitle: data.variantTitle,
          price: finalPrice,
          imageSrc: data.imageSrc,
          quantity: parseInt(quantity, 10) || 1,
          properties: cleanProps
        })
      });
      const json = await res.json();
      if (!res.ok || !json.success) {
        if (res.status === 401) {
          showToast('Session wishlist expirée. Retour au portail...', 'error', 4000);
          setTimeout(goToPortal, 2500);
          return null;
        }
        // Handler limite produits sur-mesure (Shopify Functions 11M instructions)
        if (res.status === 422 && json.code === 'SUR_MESURE_LIMIT') {
          showSurMesureLimitDialog(json.currentCount, json.max);
          return null;
        }
        showToast(`Erreur : ${json.error || 'inconnue'}`, 'error');
        return null;
      }
      const qty = parseInt(quantity, 10) || 1;
      const added = Number(json.addedAmount) || (finalPrice * qty);
      state.sessionItems += qty;
      state.sessionAmount += added;
      saveState();
      updateBanner();
      const propsCount = Object.keys(properties || {}).length;
      const suffix = propsCount > 0 ? ' avec options' : '';
      showToast(`Ajouté à votre wishlist${suffix} (${eur(added)})`, 'success');
      fetchState();
      return json;
    } catch (err) {
      console.error('[wl] network error', err);
      showToast('Erreur réseau. Vérifie ta connexion.', 'error');
      return null;
    }
  }

  async function nativeAddItemsToCart(items) {
    // POST /cart/add.js pour chaque item, en série (préserve properties, et
    // garde separees les lignes qui partagent un meme variant_id — cas des
    // sur-mesure ou N items custom pointent le meme variant "couleur" et ne
    // different que par leurs properties dimensions).
    // Gestion d'erreur PAR item : un POST qui echoue (variant indispo, 422,
    // rate limit) ne doit PAS interrompre la boucle et faire perdre les items
    // suivants. On collecte les echecs et on les retourne pour diagnostic.
    const failed = [];
    for (const item of items) {
      const formData = new FormData();
      formData.append('id', String(item.variant_id));
      formData.append('quantity', String(item.quantity || 1));

      // Copie des properties + reinjection __ooCustomPrice pour les sur-mesure
      // OPC uniquement (cf. SUR_MESURE_PRODUCT_IDS). item.product_id et
      // item.price sont fournis par l'endpoint ERP.
      // UNITE : __ooCustomPrice est en EUROS (ex. "280.80"), PAS en centimes.
      // Verifie en prod le 2026-07-17 : injecter price*100 donnait un prix x100
      // au panier (OPC lit la valeur comme des euros directs). On envoie donc
      // le prix euros a 2 decimales, comme le fait le configurateur (field1 =
      // grandTotal.toFixed(2), cf. moo-configurator-plantravail.js:199).
      const props = Object.assign({}, item.properties || {});
      const priceEur = parseFloat(item.price);
      const pid = Number(item.product_id);
      if (isFinite(pid) && SUR_MESURE_PRODUCT_IDS.has(pid)
          && !props.__ooCustomPrice && isFinite(priceEur) && priceEur > 0) {
        props.__ooCustomPrice = priceEur.toFixed(2);
      }
      for (const [k, v] of Object.entries(props)) {
        if (v != null && v !== '') formData.append(`properties[${k}]`, String(v));
      }
      try {
        const resp = await NATIVE_FETCH('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin'
        });
        if (!resp.ok) {
          let msg = 'HTTP ' + resp.status;
          try { const j = await resp.json(); msg = j.description || j.message || msg; } catch (e) {}
          failed.push({ variant_id: item.variant_id, error: msg });
          console.warn('[wl] /cart/add.js echec item', item.variant_id, msg);
        }
      } catch (err) {
        failed.push({ variant_id: item.variant_id, error: (err && err.message) || 'network' });
        console.warn('[wl] /cart/add.js exception item', item.variant_id, err);
      }
    }
    return failed;
  }

  async function transferToCart() {
    const token = localStorage.getItem(STORAGE.TOKEN);
    if (!token) { showToast('Session wishlist absente.', 'error'); return; }
    const btn = document.getElementById('moood-wl-cart');
    const oldText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Chargement...'; }
    try {
      const res = await NATIVE_FETCH(`${API_CART}?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      if (!res.ok || !data.success) {
        if (res.status === 401) {
          showToast('Session wishlist expirée.', 'error', 4000);
          setTimeout(goToPortal, 2500);
          return;
        }
        const msgByReason = {
          empty: 'Votre wishlist est vide.',
          no_valid_variants: 'Aucun produit avec variant Shopify valide.',
          too_long: 'Trop de produits pour un ajout direct. Contactez votre conseiller moood.'
        };
        showToast(msgByReason[data.reason] || data.error || 'Erreur.', 'error', 5000);
        return;
      }

      if (data.hasProperties && data.items && data.items.length) {
        // POST /cart/add.js pour préserver properties
        showOverlay('Ajout au panier...', `${data.items.length} produit${data.items.length > 1 ? 's' : ''} avec options`);
        const failed = await nativeAddItemsToCart(data.items);
        if (failed.length) {
          console.warn('[wl] transferToCart : ' + failed.length + '/' + data.items.length + ' item(s) non ajoute(s)', failed);
          showToast(failed.length + ' produit(s) sur ' + data.items.length + " n'ont pas pu etre ajoutes.", 'error', 5000);
        }
        window.location.href = '/cart';
      } else {
        showToast(`Ouverture du panier (${data.included} produit${data.included > 1 ? 's' : ''})...`, 'success');
        setTimeout(() => { window.location.href = data.url; }, 600);
      }
    } catch (err) {
      console.error('[wl] transferToCart error', err);
      showToast('Erreur réseau.', 'error');
    } finally {
      if (btn) {
        setTimeout(() => { btn.disabled = false; btn.textContent = oldText; }, 1500);
      }
    }
  }

  // Mode transfer : déclenché par URL ?wishlist_transfer=1&t=...
  async function runTransfer() {
    localStorage.removeItem(STORAGE.TRANSFER_PENDING);
    const token = localStorage.getItem(STORAGE.TOKEN);
    if (!token) { window.location.href = '/cart'; return; }

    injectStyles();
    showOverlay('Transfert de votre wishlist...', 'Veuillez patienter');

    try {
      const res = await NATIVE_FETCH(`${API_CART}?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      localStorage.removeItem(STORAGE.TOKEN);

      if (!res.ok || !data.success) {
        hideOverlay();
        alert(data.error || 'Erreur lors du transfert. Retour à la wishlist.');
        window.location.href = PORTAL_URL;
        return;
      }

      if (data.hasProperties && data.items && data.items.length) {
        const failed = await nativeAddItemsToCart(data.items);
        if (failed.length) {
          console.warn('[wl] runTransfer : ' + failed.length + '/' + data.items.length + ' item(s) non ajoute(s)', failed);
        }
        window.location.href = '/cart';
      } else {
        // Pas de properties, juste rediriger vers permalink (rapide)
        window.location.href = data.url;
      }
    } catch (err) {
      console.error('[wl] runTransfer error', err);
      hideOverlay();
      alert('Erreur réseau lors du transfert.');
      window.location.href = PORTAL_URL;
    }
  }

  function setupFormIntercept() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      const properties = extractPropertiesFromForm(form);
      if (variantId) sendToWishlist({ variantId, quantity, properties });
      else showToast('Variant introuvable sur ce produit', 'error');
    }, true);
  }

  function setupFetchIntercept() {
    window.fetch = function(input, init = {}) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add')) {
        let body = init.body;
        let payload = null;
        try {
          if (body instanceof FormData) {
            payload = {};
            for (const [k, v] of body.entries()) payload[k] = v;
          } else if (typeof body === 'string') {
            try { payload = JSON.parse(body); }
            catch {
              const p = new URLSearchParams(body);
              payload = {};
              for (const [k, v] of p.entries()) payload[k] = v;
            }
          } else if (body && typeof body === 'object') payload = body;
        } catch (e) {}
        if (payload && payload.id) {
          const properties = extractPropertiesFromPayload(payload);
          sendToWishlist({ variantId: payload.id, quantity: payload.quantity || 1, properties });
          return Promise.resolve(new Response(
            JSON.stringify({ status: 'wishlist_added', items: [] }),
            { status: 200, headers: { 'Content-Type': 'application/json' } }
          ));
        }
      }
      return NATIVE_FETCH.apply(this, arguments);
    };
  }

  function setupXhrIntercept() {
    const OriginalXHR = window.XMLHttpRequest;
    function PatchedXHR() {
      const xhr = new OriginalXHR();
      let interceptUrl = '';
      const originalOpen = xhr.open;
      const originalSend = xhr.send;
      xhr.open = function(method, url) { interceptUrl = url || ''; return originalOpen.apply(this, arguments); };
      xhr.send = function(body) {
        if (typeof interceptUrl === 'string' && interceptUrl.includes('/cart/add')) {
          let payload = null;
          try {
            if (body instanceof FormData) {
              payload = {};
              for (const [k, v] of body.entries()) payload[k] = v;
            } else if (typeof body === 'string') {
              try { payload = JSON.parse(body); }
              catch {
                const p = new URLSearchParams(body);
                payload = {};
                for (const [k, v] of p.entries()) payload[k] = v;
              }
            }
          } catch (e) {}
          if (payload && payload.id) {
            const properties = extractPropertiesFromPayload(payload);
            sendToWishlist({ variantId: payload.id, quantity: payload.quantity || 1, properties });
            Object.defineProperty(xhr, 'status', { value: 200, configurable: true });
            Object.defineProperty(xhr, 'responseText', { value: '{"status":"wishlist_added","items":[]}', configurable: true });
            setTimeout(() => {
              Object.defineProperty(xhr, 'readyState', { value: 4, configurable: true });
              if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
              if (typeof xhr.onload === 'function') xhr.onload();
            }, 50);
            return;
          }
        }
        return originalSend.apply(this, arguments);
      };
      return xhr;
    }
    window.XMLHttpRequest = PatchedXHR;
  }

  function exitMode() {
    if (!confirm('Quitter le mode wishlist ? Tu pourras y revenir depuis ton portail.')) return;
    Object.values(STORAGE).forEach(k => localStorage.removeItem(k));
    window.location.reload();
  }

  function goToPortal() { window.location.href = PORTAL_URL; }

  function relabelCartButtons() {
    const selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      'button[name="add"]',
      '.product_submit_button',
      '#moo-sm-atc'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(btn => {
      const isAtcCaisson = btn.id === 'moo-sm-atc';
      const currentText = btn.tagName === 'INPUT' ? btn.value : (btn.textContent || '').trim();
      if (currentText === 'Ajouter à la wishlist') return;
      if (!isAtcCaisson && btn.dataset.mooodWlRelabeled === '1') return;
      btn.dataset.mooodWlRelabeled = '1';

      const isInput = btn.tagName === 'INPUT';
      if (isInput) {
        btn.value = 'Ajouter à la wishlist';
      } else {
        let replaced = false;
        const replaceTextInNode = (node) => {
          if (replaced) return;
          for (const child of node.childNodes) {
            if (child.nodeType === 3 && child.textContent.trim()) {
              child.textContent = 'Ajouter à la wishlist';
              replaced = true;
              return;
            } else if (child.nodeType === 1) {
              replaceTextInNode(child);
            }
          }
        };
        replaceTextInNode(btn);
        if (!replaced) btn.textContent = 'Ajouter à la wishlist';
      }

      btn.style.setProperty('background', '#C4622A', 'important');
      btn.style.setProperty('background-color', '#C4622A', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border-color', '#C4622A', 'important');
    });
  }

  let _relabelObserver = null;
  function startCartButtonObserver() {
    if (_relabelObserver) return;
    _relabelObserver = new MutationObserver(() => relabelCartButtons());
    _relabelObserver.observe(document.body, { childList: true, subtree: true });
  }

  function handleCaissonSurMesure() {
    if (!document.querySelector('.moo-sm-page')) return;
    const form = document.getElementById('moo-sm-form');
    if (!form) return;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const couleur = document.querySelector('#moo-sm-couleur-val')?.textContent?.trim() || '';
      const poignee = document.querySelector('#moo-sm-poignee-btns .moo-sm-btn--active')?.dataset?.poignee || '';
      const typeLabel = document.querySelector('#moo-sm-type-btns .moo-sm-btn--active .option_value')?.textContent?.trim() || '';
      const utilityLabel = document.querySelector('#moo-sm-utility-btns .moo-sm-btn--active .option_value')?.textContent?.trim() || '';
      const caissonCouleur = document.querySelector('#moo-sm-caisson-btns .moo-sm-btn--active')?.dataset?.caisson || 'Blanc';
      const larg = document.querySelector('#moo-sm-larg')?.value || '';
      const haut = document.querySelector('#moo-sm-haut')?.value || '';
      const prof = document.querySelector('#moo-sm-prof')?.value || '';
      const sens = document.querySelector('#moo-sm-sens-btns .moo-sm-btn--active')?.dataset?.sens || '';
      const comment = document.querySelector('#moo-sm-comment')?.value?.trim() || '';
      const priceText = document.querySelector('#moo-sm-price-val')?.textContent?.trim() || '';
      const refName = document.querySelector('#moo-sm-ref-name')?.textContent?.trim() || '';

      if (!couleur || !poignee || !larg || !haut || !prof || !priceText || priceText === '—') {
        showToast('Configuration incomplète', 'error'); return;
      }
      const priceMatch = priceText.replace(/\s/g, '').match(/(\d+[.,]?\d*)/);
      const price = priceMatch ? parseFloat(priceMatch[1].replace(',', '.')) : 0;
      if (price <= 0) { showToast('Prix non calculé', 'error'); return; }

      let variantId = null;
      if (window.mooSMVariants?.length) {
        const v = window.mooSMVariants.find(x => x.option1 === couleur && x.option2 === poignee);
        if (v) variantId = v.id;
        else {
          const v2 = window.mooSMVariants.find(x => x.option1 === couleur);
          if (v2) variantId = v2.id;
        }
      }
      if (!variantId) { showToast('Variant introuvable', 'error'); return; }

      const variantData = window.mooSMVariants?.find(x => x.id === variantId);
      let imageSrc = variantData?.featured_image?.src || '';
      if (imageSrc.startsWith('//')) imageSrc = 'https:' + imageSrc;
      let productId = variantData?.product_id || 0;
      if (!productId) {
        try {
          const pRes = await NATIVE_FETCH('/products/caisson-sur-mesure.js');
          if (pRes.ok) {
            const pData = await pRes.json();
            productId = pData.id || 0;
          }
        } catch (e) { console.warn('[wl] product fetch failed', e); }
      }

      const properties = {};
      if (typeLabel) properties['Type'] = typeLabel;
      if (utilityLabel) properties['Type de caisson'] = utilityLabel;
      properties['Couleur caisson'] = caissonCouleur;
      properties['Poignée'] = poignee;
      properties['Dimensions'] = `L=${larg}mm H=${haut}mm P=${prof}mm`;
      if (sens && sens !== 'Non applicable') properties["Sens d'ouverture"] = sens;
      if (refName) properties['Modèle de référence'] = refName;
      if (comment) properties['Commentaire'] = comment;

      const token = localStorage.getItem(STORAGE.TOKEN);
      if (!token) { showToast('Session wishlist absente', 'error'); return; }

      const btn = document.getElementById('moo-sm-atc');
      const oldText = btn?.textContent || '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout à la wishlist...'; }

      try {
        const res = await NATIVE_FETCH(API_ADD, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token,
            variantId: parseInt(variantId, 10),
            productId,
            title: 'Caisson sur mesure',
            variantTitle: couleur + ' / ' + poignee,
            price,
            imageSrc,
            quantity: 1,
            properties
          })
        });
        const json = await res.json();
        if (!res.ok || !json.success) {
          // Handler limite produits sur-mesure (Shopify Functions 11M instructions)
          if (res.status === 422 && json.code === 'SUR_MESURE_LIMIT') {
            showSurMesureLimitDialog(json.currentCount, json.max);
            if (btn) { btn.disabled = false; btn.textContent = oldText; }
            return;
          }
          showToast(`Erreur : ${json.error || 'inconnue'}`, 'error');
          if (btn) { btn.disabled = false; btn.textContent = oldText; }
          return;
        }
        state.sessionItems += 1;
        state.sessionAmount += price;
        saveState();
        updateBanner();
        showToast(`Caisson sur mesure ajouté à la wishlist (${eur(price)})`, 'success');
        fetchState();
        if (btn) {
          btn.textContent = '✓ Ajouté à la wishlist';
          setTimeout(() => { btn.disabled = false; btn.textContent = oldText; }, 2500);
        }
      } catch (err) {
        console.error('[wl] caisson error', err);
        showToast('Erreur réseau', 'error');
        if (btn) { btn.disabled = false; btn.textContent = oldText; }
      }
    }, true);
  }

  function blockConfigurateur() {
    if (!document.querySelector('.moood-configurateur')) return;
    if (document.getElementById('moood-wl-config-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'moood-wl-config-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(23,78,68,0.94);z-index:99997;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(6px);';
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:20px;padding:40px 32px;max-width:480px;width:100%;text-align:center;box-shadow:0 25px 60px rgba(0,0,0,0.4);font-family:system-ui,-apple-system,sans-serif;">
        <div style="width:64px;height:64px;background:#fef3c7;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M12 9v4"/><path d="M12 17h.01"/><circle cx="12" cy="12" r="10"/></svg>
        </div>
        <h2 style="font-size:22px;font-weight:700;color:#174E44;margin:0 0 12px;">Configurateur indisponible en mode wishlist</h2>
        <p style="font-size:14px;color:#6b7280;line-height:1.6;margin:0 0 24px;">Le configurateur cuisine n'est pas compatible avec le mode wishlist. Parcourez le catalogue pour ajouter vos produits favoris un par un.</p>
        <div style="display:flex;flex-direction:column;gap:10px;">
          <a href="https://moood.fr/" style="display:block;background:#174E44;color:#fff;padding:14px 24px;border-radius:50px;text-decoration:none;font-weight:700;font-size:14px;">Parcourir le catalogue</a>
          <button id="moood-wl-config-exit" style="background:transparent;color:#6b7280;border:none;padding:10px;font-size:13px;cursor:pointer;text-decoration:underline;">Quitter le mode wishlist</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    document.getElementById('moood-wl-config-exit')?.addEventListener('click', exitMode);
  }

function setupStorageSync() {
    window.addEventListener('storage', function(e) {
      if (!e.key || !e.key.startsWith('moood_wl_')) return;
      // Si l'utilisateur quitte le mode wishlist depuis un autre onglet, on reload pour cleaner
      if (e.key === STORAGE.ACTIVE && e.newValue === null) {
        window.location.reload();
        return;
      }
      // Sinon, on recharge le state + banner + items
      loadState();
      updateBanner();
      fetchState();
    });
  }

  function init() {
    detectModeFromUrl();

    // Mode transfer : priorité (ne pas démarrer le mode wishlist normal)
    if (localStorage.getItem(STORAGE.TRANSFER_PENDING) === '1') {
      runTransfer();
      return;
    }

    // Mode wishlist normal
    if (!localStorage.getItem(STORAGE.ACTIVE)) return;
    if (!localStorage.getItem(STORAGE.TOKEN)) return;
    loadState();
    injectStyles();
    injectBanner();
    setupFormIntercept();
    setupFetchIntercept();
    setupXhrIntercept();
    setupPopupHoverLeave();
    fetchState({ initialOnly: true });
    blockConfigurateur();
    handleCaissonSurMesure();
    relabelCartButtons();
    startCartButtonObserver();
    setupStorageSync();
    console.log('[Moood Wishlist] Mode actif - v4 (properties + sur-mesure guard)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();